import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import '../styles/Map.css';

// Correctif classique webpack/CRA: les images d'icône par défaut de Leaflet
// ne se chargent pas sans cette réassignation explicite des URLs.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const userIcon = L.divIcon({
  className: 'user-location-marker',
  html: '<span class="user-dot"></span>',
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

// Recadre la carte pour que le rayon de recherche soit entièrement visible.
// On calcule la bounding box géographiquement (~111 km par degré de
// latitude) plutôt que via Circle.getBounds(), qui plante si le calque n'a
// pas encore été ajouté à la carte.
function FitToRadius({ lat, lon, radiusKm }) {
  const map = useMap();
  useEffect(() => {
    const latDelta = radiusKm / 111;
    const lonDelta = radiusKm / (111 * Math.cos(lat * Math.PI / 180));
    const bounds = L.latLngBounds(
      [lat - latDelta, lon - lonDelta],
      [lat + latDelta, lon + lonDelta]
    );
    map.fitBounds(bounds, { padding: [20, 20] });
  }, [map, lat, lon, radiusKm]);
  return null;
}

function Map({ lieux, userLocation, searchRadius, accentColor = '#0E7490' }) {
  const center = [userLocation.latitude, userLocation.longitude];

  return (
    <div className="map-container">
      <h2>📍 Carte interactive</h2>
      <div className="map-wrapper">
        <MapContainer center={center} zoom={14} className="leaflet-map">
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <FitToRadius lat={userLocation.latitude} lon={userLocation.longitude} radiusKm={searchRadius} />
          <Circle
            center={center}
            radius={searchRadius * 1000}
            pathOptions={{ color: accentColor, fillColor: accentColor, fillOpacity: 0.08 }}
          />
          <Marker position={center} icon={userIcon}>
            <Popup>Vous êtes ici</Popup>
          </Marker>
          {lieux.map(l => (
            <Marker key={l.id} position={[l.latitude, l.longitude]}>
              <Popup>
                <strong>{l.nom}</strong><br />
                {l.distance.toFixed(2)} km
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}

export default Map;
